//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import {
  IProductFeedHealthHistoryResponse,
  IProductFeedHealthOverviewResponse,
  IProductFeedHealthStatus,
} from '@apis/product-feed-health/productFeedHealthApiModels';
import CatalogId from '@models/CatalogId';
import { serializedSessionFetch } from '@utils/sessionFetch';

export async function getFeedMetadata(
  catalogId: CatalogId,
): Promise<IProductFeedHealthStatus> {
  const params = {
    catalogId,
  };
  const res = await serializedSessionFetch(
    `/api/feed/health/status?${$.param(params)}`,
  );
  return res.json<IProductFeedHealthStatus>();
}

export async function getHistoryItems(
  catalogId: CatalogId,
): Promise<IProductFeedHealthHistoryResponse> {
  const params = {
    catalogId,
  };
  const res = await serializedSessionFetch(
    `/api/feed/health/history?${$.param(params)}`,
  );
  return res.json<IProductFeedHealthHistoryResponse>();
}

export async function getOverviewItems(
  init?: RequestInit,
): Promise<IProductFeedHealthOverviewResponse> {
  const res = await serializedSessionFetch('/api/feeds', init);
  return res.json<IProductFeedHealthOverviewResponse>();
}
